export default __webpack_public_path__ + "23fc36c6bd5930ad21ecfdf628a30773.png";